// create a default instance of theme to be used
const theme = {
  palette: {},
};

export default theme;
